import { i18n } from '@lingui/core'
import React from 'react'

export const useLanguage = (language) => {
  React.useEffect(() => {
    if (language) {
      async function activateLanguage(locale, isFallback = false) {
        try {
          const { messages } = await import(
            /* webpackChunkName: "i18n-[index]" */ `../locales/${locale}/messages.ts`
          )
          if (typeof window !== 'undefined') {
            // @ts-ignore
            window.__localeId__ = locale
          }

          i18n.loadAndActivate({ locale, messages })
          i18n.on('missing', (event) => {
            return event.id
          })
        } catch (error) {
          if (!isFallback && locale !== 'da') {
            activateLanguage('da', true)
          }
        }
      }
      activateLanguage(language)
    }
  }, [language])
}
